import { useState } from 'react';
import styled from 'styled-components';
import { button, spacing, colors, borderRadius } from 'ui/theme';
import {
  CollapsibleContent,
  CollapsibleContentArrow,
  ARROW_DIRECTION_UP,
  ARROW_DIRECTION_DOWN,
} from 'ui/collapsibleContent';

import { CHECKBOX_STATUS, Checkbox } from 'ui/checkbox';

import { ExpandableCategoryProps } from './types';

export const StyledWrapper = styled.div`
  ${button};
`;

export const StyledContent = styled(CollapsibleContent)`
  margin-left: ${spacing.base};
  border-left: ${spacing.single} solid ${colors.grey15};
`;

export const StyledTrigger = styled.div`
  display: flex;
  padding: ${spacing.half};
  align-items: center;
  border-radius: ${borderRadius.md};
  :hover {
    background-color: ${colors.backgroundPrimaryHover};
  }
`;

export const ClickableContent = styled.div`
  cursor: pointer;
  display: flex;
  width: 100%;
  padding-left: ${spacing.half};
  justify-content: space-between;
`;

export const StyledCount = styled.span`
  padding-right: ${spacing.quarter};
  color: ${colors.textSecondary};
`;
export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpandableCategoryGroup = ({
  label,
  isCollapsible = true,
  isSelected,
  onClick,
  count,
  children,
  ...props
}: ExpandableCategoryProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const getCheckboxStatus = () => {
    if (isSelected === undefined) return CHECKBOX_STATUS.UNCHECKED;
    if (typeof isSelected === 'boolean')
      return isSelected ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED;
    return isSelected;
  };

  return (
    <StyledWrapper {...props}>
      <StyledTrigger data-test="expandable-group-trigger">
        <Checkbox status={getCheckboxStatus()} onClick={onClick} />
        <ClickableContent
          data-test="expandable-group-trigger-content"
          onClick={isCollapsible ? () => setIsCollapsed(!isCollapsed) : onClick}
        >
          {label}
          {isCollapsible && (
            <ArrowContainer>
              <StyledCount>{count}</StyledCount>
              <CollapsibleContentArrow
                width={16}
                height={16}
                isCollapsed={isCollapsed}
                arrowStart={ARROW_DIRECTION_DOWN}
                arrowEnd={ARROW_DIRECTION_UP}
              />
            </ArrowContainer>
          )}
        </ClickableContent>
      </StyledTrigger>
      <StyledContent isCollapsed={isCollapsed}>{children}</StyledContent>
    </StyledWrapper>
  );
};
